// extracted by mini-css-extract-plugin
export default {"emailLink_medium":"EmailInline_emailLink_medium__RaW+H","emailLink_small":"EmailInline_emailLink_small__46o8x","emailLink_large":"EmailInline_emailLink_large__jWMUG"};